import type {AppLanguage} from 'platform/locale';

const capitalizeFirstCharacter = (value: string, locale: AppLanguage) => {
  const [firstCharacter, ...remainingCharacters] = [...value];

  return `${firstCharacter?.toLocaleUpperCase(locale) ?? ''}${remainingCharacters.join('')}`;
};

export const formatWeekday = (date: Date, locale: AppLanguage) =>
  capitalizeFirstCharacter(new Intl.DateTimeFormat(locale, {weekday: 'long'}).format(date), locale);
